import getFolderFromId from '../utils/folderTypeConversionUtil';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { lazyOnBulkActionSubmitted } from 'owa-bulk-action-store';
import applyBulkItemActionService from '../services/applyBulkItemActionService';
import runRuleNow from '../actions/actionCreators/runRuleNow';
import { orchestrator } from 'satcheljs';
export default orchestrator(runRuleNow, function (actionMessage) {
    var mailboxesToSweep = [];
    var destinationFolderId;
    var senderSMTPs = [];
    var bulkActionCustomData;
    var inboxRule = actionMessage.inboxRule;
    var sourceFolderId = actionMessage.sourceFolderId;
    if (inboxRule.From) {
        for (var _i = 0, _a = inboxRule.From; _i < _a.length; _i++) {
            var identity = _a[_i];
            var mailbox = {
                Name: identity.DisplayName,
                EmailAddress: identity.SmtpAddress,
                RoutingType: identity.RoutingType,
            };
            mailboxesToSweep.push(mailbox);
            senderSMTPs.push(identity.SmtpAddress);
        }
    }
    else {
        throw new Error('Cannot run rule without sender(s)');
    }
    if (inboxRule.MoveToFolder) {
        var destinationFolder = getFolderFromId(inboxRule.MoveToFolder.RawIdentity);
        if (!destinationFolder) {
            throw new Error('Destination folder does not exist in store');
        }
        else {
            destinationFolderId = destinationFolder.folderId;
        }
    }
    else if (inboxRule.DeleteMessage) {
        destinationFolderId = folderNameToId('deleteditems');
    }
    else {
        throw new Error('Cannot run rule without destination folder');
    }
    bulkActionCustomData = {
        Scenario: 'RunRuleNow',
        ruleName: inboxRule.Name,
        ruleId: inboxRule.Identity.RawIdentity,
    };
    lazyOnBulkActionSubmitted.importAndExecute(sourceFolderId ? sourceFolderId : folderNameToId('inbox'), 'Sweep', bulkActionCustomData);
    applyBulkItemActionService(0 /* Move */, mailboxesToSweep, sourceFolderId ? sourceFolderId : folderNameToId('inbox'), 1 /* Items */, 0, destinationFolderId, bulkActionCustomData);
});
//# sourceMappingURL=runRuleNowOrchestrator.js.map